const site = () => {
  /**
   * Плавный скролл
   */
  function setNavigation() {
    $("a[href^='#']").on(
      "click",
      function (e) {
        e.preventDefault();
        $("html,body")
          .stop()
          .animate(
            {
              scrollTop:
                $(`#${this.href.split("#").pop()}`).offset()?.top - 100,
            },
            700
          );
      }
    );
  }

  /* Инициализация */
  $(function () {
    setNavigation();
  });

  /**
   * Пользователь находится на сайте больше 30 сек
   */
  setTimeout(() => {
    VK.Retargeting.Event('PageView30sec');
  }, 30000);
};

export default site;
